import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ThemeStore } from '@indutrust/shared-data';
import { provideTranslocoScopeSharedThemeToggle } from '@indutrust/shared-util';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonDirective } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

/**
 * A button that toggles the application between light and dark mode
 * by calling {@link ThemeStore.toggleDarkMode}.
 *
 * @example
 * <idt-theme-toggle />
 */
@Component({
  selector: 'idt-theme-toggle',
  imports: [ButtonDirective, Tooltip, TranslocoDirective],
  template: `
    <ng-container *transloco="let t; prefix: 'sharedTt'">
      <button
        iconOnly
        pButton
        severity="secondary"
        size="small"
        tooltipPosition="bottom"
        type="button"
        [attr.aria-label]="
          themeStore.isDarkTheme() ? t('switchToLight') : t('switchToDark')
        "
        [pTooltip]="
          themeStore.isDarkTheme() ? t('switchToLight') : t('switchToDark')
        "
        [positionTop]="8"
        [rounded]="true"
        [text]="false"
        (click)="toggle()">
        <i
          aria-hidden="true"
          [class]="themeStore.isDarkTheme() ? 'pi pi-moon' : 'pi pi-sun'"></i>
      </button>
    </ng-container>
  `,
  providers: [provideTranslocoScopeSharedThemeToggle()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent {
  protected readonly themeStore = inject(ThemeStore);

  protected toggle(): void {
    this.themeStore.toggleDarkMode();
  }
}
